var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletDarkGrayIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3947 17.1042V18.2153C20.3947 19.4375 19.4 20.4375 18.1842 20.4375H2.71053C1.48368 20.4375 0.5 19.4375 0.5 18.2153V2.65972C0.5 1.4375 1.48368 0.4375 2.71053 0.4375H18.1842C19.4 0.4375 20.3947 1.4375 20.3947 2.65972V3.77083H10.4474C9.22053 3.77083 8.23684 4.77083 8.23684 5.99306V14.8819C8.23684 16.1042 9.22053 17.1042 10.4474 17.1042H20.3947ZM10.4474 14.8819H21.5V5.99306H10.4474V14.8819ZM14.8684 12.1042C13.9511 12.1042 13.2105 11.3597 13.2105 10.4375C13.2105 9.51528 13.9511 8.77083 14.8684 8.77083C15.7858 8.77083 16.5263 9.51528 16.5263 10.4375C16.5263 11.3597 15.7858 12.1042 14.8684 12.1042Z",
    fill: "#4C6672"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletDarkGrayIcon);
export default __webpack_public_path__ + "static/media/wallet-dark-gray-icon.73ef40a4ce29ef0cdad50791728e2b4c.svg";
export { ForwardRef as ReactComponent };